import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  fieldDictionaryAll: [],
  fieldDictionary: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const fieldDictionarySlice = createSlice({
  name: "fieldDictionary",
  initialState,
  reducers: {
    setFieldDictionaryAll: (state, action) => {
      state.fieldDictionaryAll = action.payload;
    },
    setFieldDictionary: (state, action) => {
      state.fieldDictionary = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setFieldDictionaryAll,
  setFieldDictionary,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = fieldDictionarySlice.actions;

export default fieldDictionarySlice.reducer;
